// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3_NLF","left":"InfoRow_left__2jFJi"};